import styled, { keyframes } from 'styled-components';

const animationHideOpacity = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const animationShowOpacity = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

interface Props {
  isOpen?: boolean,
  isLoading?: boolean,
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: ${(props: Props) => props.isOpen ? 'flex' : 'none'};
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
`;

const Content = styled.div`
  background: #fff;
  width: 350px;
  z-index: 1000;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const NumberContent = styled.div`
  width: 100%;
  margin-top: 20px;
  z-index: 1;

  &.hide {
    animation: ${animationHideOpacity} 0.5s ease-in-out;
    opacity: 0;
  }
  &.show {
    animation: ${animationShowOpacity} 0.5s ease-in-out;
    opacity: 1;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Number = styled.div`
  width: 33%;
  /* height: 100px; */
  color: #05d6e1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  padding: 30px;
  font-weight: 700;
  letter-spacing: -0.5px;

  &:hover, &:active, &:focus {
    opacity: 0.3;
  }
`;

const Input = styled.input`
  width: 100%;
  border: 0;
  border-bottom: 1px solid #dcdcdc;
  padding: 8px 15px;
  font-size: 32px;
  font-weight: 500;
  color: #1a1a1a;
  margin-top: 10px;
  text-align: center;
  letter-spacing: 10px;

  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const Text = styled.p`
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #ddd;
`;

const Loader = styled.div`
  height: 368px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;

  &.hide {
    animation: ${animationHideOpacity} 0.5s ease-in-out;
    opacity: 0;
  }
  &.show {
    animation: ${animationShowOpacity} 0.5s ease-in-out;
    opacity: 1;
  }
`;

export {
  Wrapper,
  Background,
  Content,
  NumberContent,
  Row,
  Number,
  Input,
  Text,
  Loader,
};
